export { gql } from '@apollo/client';
